/**
 * Scrolle jusqu'au haut de page au clic.
 *
 * @param {string} selecteur Le sélecteur CSS de l'élément aur lequel écouter le clic.
 */
const animerRetourHautDePage = selecteur => {
    document.querySelector(selecteur).addEventListener("click", event => {
        event.preventDefault();

        $("html, body").animate(
            {
                scrollTop: 0
            },
            700
        );
    });
};

export { animerRetourHautDePage };
